import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../rootReducer';
import { setBalance } from './enhancers/setBalance';
import { setGeoToOffers } from './enhancers/setGeoToOffers';
import { setSitesSettings } from './enhancers/setSitesSettings';
import { setUnreadTickets } from './enhancers/setUnreadTickets';
import { setLang } from './enhancers/setLang';
import { redirectToPaymentsData } from './enhancers/redirectToPaymentsData';
import { redirectToAgenciesData } from './enhancers/redirectToAgenciesData';

const composeEnhancers =
  !PRODUCTION && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

export default () => {
  const store = createStore(
    rootReducer,
    composeEnhancers(
      applyMiddleware(
        thunk,
        setBalance,
        setUnreadTickets,
        setGeoToOffers,
        setSitesSettings,
        setLang,
        redirectToPaymentsData,
        redirectToAgenciesData,
      ),
    ),
  );

  return store;
};
